'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactIntl = require('react-intl');

var _DefaultString = require('../../helpers/DefaultString');

var _Addresses = require('./Addresses.scss');

var _Addresses2 = _interopRequireDefault(_Addresses);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Addresses = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Addresses, _Component);

  function Addresses() {
    (0, _classCallCheck3.default)(this, Addresses);
    return (0, _possibleConstructorReturn3.default)(this, (Addresses.__proto__ || (0, _getPrototypeOf2.default)(Addresses)).apply(this, arguments));
  }

  (0, _createClass3.default)(Addresses, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _Addresses2.default.addresses },
        _react2.default.createElement(
          'div',
          { className: _Addresses2.default.addressesContent },
          _react2.default.createElement(
            'div',
            { className: _Addresses2.default.title },
            _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Addresses)
          ),
          _react2.default.createElement(
            'div',
            { className: _Addresses2.default.mailAddress },
            _react2.default.createElement(_reactIntl.FormattedHTMLMessage, _DefaultString.translations.ContactUsByMailAddress)
          )
        )
      );
    }
  }]);
  return Addresses;
}(_react.Component), _class2.propTypes = {
  pushState: _react.PropTypes.func.isRequired
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(Addresses);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Addresses/Addresses.js
// module id = 1990
// module chunks = 0